export default "__VITE_ASSET__7dcc822d__"